import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={(styles["codicon"] || "codicon") + " " + (styles["codicon-tile"] || "codicon-tile")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.96 24.96" {...props}><path d="M0 0h9.92v9.92H0zM15.04 0h9.92v9.92h-9.92zM0 15.04h9.92v9.92H0zM15.04 15.04h9.92v9.92h-9.92z" /></svg>;